module.exports = __webpack_public_path__ + "img/card-img3.73731f86.png";